exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".flash {\n    width: 100%;\n    position: absolute;\n    /* left: calc(100vw - 957px); */\n    /* top: 1%; */\n    z-index: 1040;\n    text-align: center\n}\n.flash:first-letter {text-transform:uppercase}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/bharath/agira-projects/asmart/agira-intranet-ui/src/app/flash/flash.component.css
// module id = ../../../../../src/app/flash/flash.component.css
// module chunks = main